/** A skin changes the shared cabinet's materials, never its playback state. */
export const SKINS = [
  { id: "heritage", name: "Heritage", description: "Warm walnut · aged brass" },
  { id: "space-age", name: "Space Age", description: "Ivory cabinet · polished chrome" },
  { id: "studio", name: "Studio", description: "Charcoal · brushed aluminum" }
] as const;

export type SkinId = (typeof SKINS)[number]["id"];

export const DEFAULT_SKIN: SkinId = "heritage";
export const APPEARANCE_STORAGE_KEY = "serendiptv.appearance.v1";

function isSkinId(value: unknown): value is SkinId {
  return SKINS.some((skin) => skin.id === value);
}

/** Read before the first cabinet render, with no dependency on profile/API setup. */
export function loadSkin(): SkinId {
  if (typeof window === "undefined") return DEFAULT_SKIN;

  try {
    const raw = window.localStorage.getItem(APPEARANCE_STORAGE_KEY);
    const stored: unknown = raw ? JSON.parse(raw) : null;
    if (stored && typeof stored === "object" && "skin" in stored && isSkinId(stored.skin)) {
      return stored.skin;
    }
  } catch {
    // Private browsing, denied storage, and corrupt data must not delay the TV.
  }

  return DEFAULT_SKIN;
}

/** The caller retains its React state when persistence is unavailable. */
export function persistSkin(skin: SkinId): boolean {
  if (typeof window === "undefined" || !isSkinId(skin)) return false;

  try {
    window.localStorage.setItem(APPEARANCE_STORAGE_KEY, JSON.stringify({ skin }));
    return true;
  } catch {
    return false;
  }
}
